<div>
<ul class="nav nav-tabs" *ngIf="hideTabTile !== 'false'">
  <li *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active" style="margin:18px 0 -1px 0;">
    <a  *ngIf="tab.role ? (isInRole$(tab.role) | async) : true">{{tab.title}}</a>
  </li>
</ul>
</div>
<ng-content></ng-content>
<storever-edit-tabs #componentContainer
                    [tabDisplay]="tabDisplay"
                    [data]="data">
</storever-edit-tabs>
